<div class="dropdownWrapper">
  <button #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation()" [disabled]="disabled"
    [matMenuTriggerFor]="menu" mat-icon-button>
    <mat-icon>arrow_drop_down</mat-icon>

  </button>

  <mat-menu #menu="matMenu">

    <button (click)="onSelectAllClick($event)" mat-menu-item>
      <span>Seleziona tutti</span>
    </button>

    <button (click)="onDeselectAllClick($event)" mat-menu-item>
      <span>Deseleziona tutti</span>
    </button>

    <button (click)="onInvertClick($event)" mat-menu-item>
      <span>Inverti</span>
    </button>

  </mat-menu>
</div>
